export default class Block {
  constructor(index, seats, status, group) {
    this.index  = index;
    this.seats  = seats;
    this.group  = group;
    this.status = status;

    seats.forEach((seat, key) => {
      seat.block   = this;
      seat.key     = key;
      seat.valid   = null;
      seat.options = null;
    });
  }

  getStatus(delta) {
    return delta ? this.nth(delta)?.getStatus() : this.status;
  }

  count(delta) {
    return delta ? (this.nth(delta)?.count() ?? 0) : this.seats.length;
  }

  get(index) {
    return this.group.blocks[index] || null;
  }

  nth(delta = 0) {
    if (delta === 0) return this;
    return this.get(this.index + delta);
  }

  prev(delta = 1) {
    return this.nth(-delta);
  }

  next(delta = 1) {
    return this.nth(delta);
  }

  exists(delta) {
    return (delta ? this.nth(delta)?.exists() : this.getStatus()) || false;
  }

  doesntExist(delta) {
    return !this.exists(delta)
  }

  isEmpty(delta) {
    return this.getStatus(delta) === 'empty';
  }

  isNotEmpty(delta) {
    return !this.isEmpty(delta);
  }

  isSelected(delta) {
    return this.getStatus(delta) === 'selected';
  }

  isNotSelected(delta) {
    return !this.isSelected(delta);
  }

  isBlocked(delta) {
    return ['blocked', undefined].includes(this.getStatus(delta));
  }

  isNotBlocked(delta) {
    return !this.isBlocked(delta);
  }
}
